/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import {getResource} from "../../../selectors/generic";
import React from "react";

export const OptionalBundleCell = ({product, fallbackImage, translate}) => {
    return <>{[
        <div key={"image"} className={'p-minicart-product__image'}>
            <div className={'p-minicart-product__img bg-lazyload lazyload'}
                 style={{backgroundImage: `url("${getResource(product.skuImageUrl || product.imageUrl || fallbackImage)}")`}}/>
        </div>,
        <div key={"name"} className="p-minicart-product-name">
            {product.productUrl ?
                <a href={product.productUrl}>{product.quantity} x {product.aemProdName}</a> :
                <p>{product.quantity} x {product.aemProdName}</p>}
            <div className="p-minicart-product-price">
                {!product.isFreeGood ?
                    <div>{product.unitPrice} <span>{translate('each')}</span></div> :
                    <div className="promoted-value">{translate('Free')}</div>}
            </div>
        </div>
    ]}</>
};
